import { connect } from 'react-redux';
import CustomDataExport from './CustomDataExport';
import { getUserInfo } from 'src/store/Dashboard/actions';

const mapStateToProps = ({ dashboard }) => ({
  user: dashboard.user,
});

const CustomDataExportTool = connect(mapStateToProps, {
  getUserInfo,
})(CustomDataExport);

export default CustomDataExportTool;
